import React, { useContext, useEffect } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { useMediaQuery, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles'
import { useHistory, useLocation } from 'react-router'
import Header from '../Header'
import { NotificationsContext } from '../../contexts/NotificationsContext/NotificationsContext'
import {
  clearNavigationOrigins,
  decomposeMarketPath, formCommentLink,
  formMarketLink,
  navigate,
  preventDefaultAndProp
} from '../../utils/marketIdPathFunctions';
import LoadingDisplay from '../../components/LoadingDisplay';
import { SearchResultsContext } from '../../contexts/SearchResultsContext/SearchResultsContext'
import { getInboxCount } from '../../contexts/NotificationsContext/notificationsContextHelper'
import { useSyncedMessages } from '../../contexts/SyncedMessagesContext/SyncedMessagesContext'
import { MarketsContext } from '../../contexts/MarketsContext/MarketsContext'
import { MarketPresencesContext } from '../../contexts/MarketPresencesContext/MarketPresencesContext'
import { InvestiblesContext } from '../../contexts/InvestibesContext/InvestiblesContext'
import Sidebar from '../../components/Menus/Sidebar'
import { RenderCensus } from '../../utils/renderProfiler'
import { useInitialSyncComplete } from '../../api/useInitialSyncComplete'
import { Group, GroupOutlined, MoreVert } from '@material-ui/icons';
import {
  getCurrentGroup,
  getCurrentWorkspace,
  getFirstWorkspace, getGroupForCommentId,
  getGroupForInvestibleId, getPlanningMarketId,
  setCurrentGroup,
  setCurrentWorkspace
} from '../../utils/redirectUtils';
import { MarketGroupsContext } from '../../contexts/MarketGroupsContext/MarketGroupsContext'
import { useIntl } from 'react-intl'
import WorkspaceMenu from '../../pages/Home/WorkspaceMenu'
import {
  COMPOSE_WIZARD_TYPE,
  DEMO_TYPE,
  PLANNING_TYPE
} from '../../constants/markets';
import {
  getMarket,
  getNotHiddenMarketDetailsForUser,
  getSortedMarkets
} from '../../contexts/MarketsContext/marketsContextHelper';
import queryString from 'query-string'
import { AccountContext } from '../../contexts/AccountContext/AccountContext'
import { DIALOG_OUTSET_STATE_HACK } from '../../pages/Dialog/Planning/DialogOutset';
import { GroupMembersContext } from '../../contexts/GroupMembersContext/GroupMembersContext';
import {
  getGroupPresences,
  getMarketPresences, isAutonomousGroup
} from '../../contexts/MarketPresencesContext/marketPresencesHelper';
import { OnboardingState, userIsLoaded } from '../../contexts/AccountContext/accountUserContextHelper';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { getComment, getMarketComments } from '../../contexts/CommentsContext/commentsContextHelper';
import { TODO_TYPE } from '../../constants/comments';
import { RED_LEVEL } from '../../constants/notifications';
import { CommentsContext } from '../../contexts/CommentsContext/CommentsContext';
import jwt_decode from 'jwt-decode';
import { fixName, getMarketInfo } from '../../utils/userFunctions';
import Gravatar from '../../components/Avatars/Gravatar';
import OtherWorkspaceMenus from '../../pages/Home/OtherWorkspaceMenus';
import { findMessagesForGroupId } from '../../utils/messageUtils';
import {
  firstDisplayedCriticalBug, openCriticalBug, useOpenChipNotification
} from '../../utils/openChipNotification';
import { getInvestible } from '../../contexts/InvestibesContext/investiblesContextHelper';
import { getGroup } from '../../contexts/MarketGroupsContext/marketGroupsContextHelper';
import { INDEX_COMMENT_TYPE, INDEX_INVESTIBLE_TYPE } from '../../contexts/SearchIndexContext/searchIndexContextMessages';
import { DARK_ACTION_BUTTON_COLOR, DARK_SIDEBAR_COLOR, SIDEBAR_COLOR } from '../../components/Buttons/ButtonConstants';
import { ThemeModeContext } from '../../contexts/ThemeModeContext';
import { clearNavigations } from '../../contexts/NotificationsContext/notificationsContextReducer';

export const screenStyles = makeStyles((theme) => ({
  hidden: {
    display: 'none',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflowX: 'hidden'
  },
  container: {
    padding: '46px 20px',
    overflowX: 'hidden'
  },
  containerAll: {
    padding: '24px 20px',
    overflowX: 'hidden',
    marginTop: '65px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: '24px 12px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0px 12px 60vh 12px',
    },
  },
  containerAllLeftPad: {
    padding: '10px 20px 0px 24px',
    overflowX: 'hidden',
    marginTop: '65px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: '24px 12px 156px',
    },
  },
  containerAllNoPad: {
    overflowX: 'hidden',
    marginTop: '65px',
    width: '100%',
  },
  bannerContainer: {
    position: 'sticky',
    top: 0,
  },
  navListIcon: {
    marginRight: 6,
    height: 16,
    width: 16
  },
  navListItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e0e0e0'
    }
  },
  navListItemGrouped: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e0e0e0'
    },
    paddingBottom: 0,
    paddingTop: 0
  },
  paper: {
    // See https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/Drawer/Drawer.js
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    // Match the sidebar panel color so the area behind the menu is uniform
    // with it (T-all-2173). Constant in ButtonConstants for easy tuning.
    backgroundColor: theme.palette.type === 'dark' ? DARK_SIDEBAR_COLOR : SIDEBAR_COLOR,
    height: '100%',
    zIndex: 8,
    position: 'fixed',
    top: '3.5rem',
    paddingBottom: '4rem',
    minWidth: '16rem',
    textOverflow: 'ellipsis'
  },
  actionContainer: {
    marginTop: '5rem',
    marginBottom: '-6rem'
  },
  contentNoStyle: {
    overflowX: 'hidden'
  },
  pending: {
    maxWidth: '85%',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  content: {
    marginLeft: '15rem',
    overflowX: 'hidden',
    height: 'calc(100vh - 1px)'
  },
  contentSearch: {
    paddingLeft: '33rem'
  },
  disabled: {
    color: theme.palette.text.disabled
  },
  navGroupHeader: {
    fontWeight: 'bold',
    textDecoration: 'underline'
  },
  navGroupGreyed: {
    color: theme.palette.text.disabled,
    textDecoration: 'underline'
  },
  smallGravatar: {
    width: '20px',
    height: '20px',
    marginTop: '2px'
  },
  elevated: {
    zIndex: 99,
  },
}));

function isAutonomousGroupCheck(group, marketId, marketPresences, groupPresencesState) {
  const groupPresences = getGroupPresences(marketPresences, groupPresencesState, marketId,
    group?.id) || [];
  return isAutonomousGroup(groupPresences, group);
}

export function getActiveGroupId(myPresence, groupsState, marketId, marketPresences, groupPresencesState, useGroupId, investibleId, 
  investiblesState) {
  let activeGroupId = useGroupId;
  // This is to correct to an autonomous group - not generate a group ID where there is none
  if (useGroupId) {
    const clickedGroupId = getCurrentGroup();
    if (clickedGroupId && investibleId && clickedGroupId !== useGroupId) {
      const clickedGroup = getGroup(groupsState, marketId, clickedGroupId);
      const clickedGroupIsAutonomous = isAutonomousGroupCheck(clickedGroup, marketId, marketPresences, groupPresencesState);
      if (clickedGroupIsAutonomous) {
        const investible = getInvestible(investiblesState, investibleId);
        const marketInfo = getMarketInfo(investible, marketId) || {};
        const { assigned } = marketInfo;
        const groupPresences = getGroupPresences(marketPresences, groupPresencesState, marketId, useGroupId) || [];
        if (assigned?.includes(myPresence.id)) {
          activeGroupId = clickedGroupId;
        } else if (_.isEmpty(assigned) && !_.isEmpty(groupPresences.find((presence) => presence.id === myPresence.id))) {
          activeGroupId = clickedGroupId;
        }
      }
    }
  }
  return activeGroupId;
}

export function getSidebarGroups(isDark, navListItemTextArray, groupsState, marketPresencesState, groupPresencesState,
  history, market, useGroupId, groupId, classes, useHoverFunctions, search, results, openMenuItems=[], inactiveGroups=[], pathname, resetFunction,
  mobileLayout, syncedMessages, commentsState, investiblesState, investibleId, syncComplete = true,
  navigateFromLeftNav = (navigation) => navigation(), openChipNotification, notificationMessages) {
  const marketId = market.id;
  const marketPresences = getMarketPresences(marketPresencesState, marketId) || [];
  const itemsSorted = _.sortBy(groupsState[marketId],
    (group) => isAutonomousGroupCheck(group, marketId, marketPresences, groupPresencesState), 'name');
  const myPresence = marketPresences.find((presence) => presence.current_user) || {};
  const itemsRaw = itemsSorted.map((group) => {
    const activeGroupId = getActiveGroupId(myPresence, groupsState, marketId, marketPresences, groupPresencesState, useGroupId, investibleId, 
      investiblesState);
    const isChosen = group.id === activeGroupId;
    const groupPresences = getGroupPresences(marketPresences, groupPresencesState, marketId, group.id) || [];
    if (_.isEmpty(groupPresences)) {
      inactiveGroups.push(group);
      if (!isChosen) {
        return {};
      }
    }
    const isGravatarDisplay = isAutonomousGroup(groupPresences, group);
    const singlePresence = isGravatarDisplay ? groupPresences[0] : undefined;
    const myIcon = isGravatarDisplay ?
      <Gravatar name={fixName(singlePresence.name)} email={singlePresence.email}  className={classes.smallGravatar}/>
       : groupPresences.find((presence) => presence.id === myPresence.id) ? Group : GroupOutlined;
    const outsetAvailable = isChosen && useHoverFunctions;
    let num = undefined;
    let numSuffix = undefined;
    let hasCritical = false;
    let onChipClick = undefined;
    let chipTooltipId = undefined;
    if (!_.isEmpty(search)) {
      const groupResults = (results || []).filter((item) => item.groupId === group.id);
      const groupLevelResults = []
      groupResults.forEach((item) => {
        if (item.type === INDEX_COMMENT_TYPE) {
          const comment = getComment(commentsState, marketId, item.id);
          if (comment) {
            if (comment.investible_id) {
              if (!groupLevelResults.includes(comment.investible_id)) {
                groupLevelResults.push(comment.investible_id);
              }
            } else {
              groupLevelResults.push(comment.id);
            }
          }
        } else if (item.type === INDEX_INVESTIBLE_TYPE) {
          if (!groupLevelResults.includes(item.id)) {
            groupLevelResults.push(item.id);
          }
        }
      });
      num = _.size(groupLevelResults);
      numSuffix = 'total';
    } else if (!outsetAvailable && syncComplete) {
      // B-all-570: the count badges walk every message per group (and every market comment
      // for critical bugs) per render, so they wait for sync convergence; the rows render
      // immediately and the counts fill in once, no flicker, when the latch flips
      // J-all-440: the synced set, so a view badge never advertises a notification the user
      // cannot open yet.
      let groupMessages = findMessagesForGroupId(group.id, syncedMessages, true);
      if (_.isEmpty(groupMessages)) {
        groupMessages = findMessagesForGroupId(group.id, syncedMessages, false);
        numSuffix = 'total';
      } else {
        numSuffix = 'new';
      }
      let count = groupMessages.length;
      const immediateBugs = getMarketComments(commentsState, marketId, group.id).filter((comment) =>
        comment.comment_type === TODO_TYPE && !comment.investible_id && !comment.resolved &&
        comment.notification_type === RED_LEVEL);
      if (numSuffix === 'total' && groupPresences.find((presence) => presence.id === myPresence.id)) {
        // B-all-529: a member otherwise gets no signal to enter the view when it holds open
        // critical bugs - non-members opted out of the view's bugs by not joining
        const criticalBugs = immediateBugs.filter((comment) =>
          !groupMessages.find((message) => message.comment_id === comment.id));
        count += criticalBugs.length;
        // B-all-538: a count that includes critical bugs must read as critical, not routine
        hasCritical = !_.isEmpty(criticalBugs);
      }
      if (numSuffix === 'new') {
        onChipClick = () => openChipNotification(groupMessages);
        chipTooltipId = 'notificationGoTo';
      } else if (hasCritical) {
        const bug = firstDisplayedCriticalBug(immediateBugs, notificationMessages);
        onChipClick = () => openCriticalBug(history, bug);
        chipTooltipId = 'notificationGoToBug';
      }
      if (count > 0) {
        num = count;
      }
    }
    const groupName = market.object_type === DEMO_TYPE && group.name === 'Single' && isGravatarDisplay ? singlePresence.name : group.name;
    return {icon: myIcon, complexIcon: isGravatarDisplay, iconColor: isDark ? DARK_ACTION_BUTTON_COLOR : 'black', 
      endIcon: outsetAvailable ? MoreVert : undefined,
      text: groupName, num, numSuffix, hasCritical, onChipClick, chipTooltipId,
      isBold: isChosen, openMenuItems: isChosen ? openMenuItems : undefined,
      isBlue: groupId === group.id || pathname === '/',
      resetFunction: isChosen ? resetFunction : undefined,
      onClickFunc: (event) => {
        if (!mobileLayout) {
          preventDefaultAndProp(event);
        } 
        if (outsetAvailable) {
          const dialogOutset = document.getElementById('dialogOutset');
          if (dialogOutset) {
            if (DIALOG_OUTSET_STATE_HACK.timerId) {
              clearTimeout(DIALOG_OUTSET_STATE_HACK.timerId);
              DIALOG_OUTSET_STATE_HACK.timerId = undefined;
            }
            dialogOutset.style.display = 'block';
          }
        } else {
          navigateFromLeftNav(() => {
            setCurrentGroup(group.id);
            navigate(history, formMarketLink(marketId, group.id));
          });
        }
      },
      onLeaveFunc: () => {
        if (isChosen && useHoverFunctions) {
          const dialogOutset = document.getElementById(`dialogOutset`);
          if (dialogOutset) {
            DIALOG_OUTSET_STATE_HACK.timerId = setTimeout(function () {
              if (DIALOG_OUTSET_STATE_HACK.open !== 1) {
                dialogOutset.style.display = 'none';
              }
            }, 2000);
          }
        }
      }
    }
  });
  const items = itemsRaw.filter((item) => !_.isEmpty(item));
  navListItemTextArray.push(...items);
}

function Screen(props) {
  const classes = screenStyles();
  const theme = useTheme();
  const intl = useIntl();
  const mobileLayout = useMediaQuery(theme.breakpoints.down('md'));
  const [userState] = useContext(AccountContext);
  const history = useHistory();
  const location = useLocation();
  const [themeMode] = useContext(ThemeModeContext);
  const isDark = themeMode === 'dark';
  const { pathname, search: querySearch, hash } = location;
  const { action, marketId: pathMarketIdRaw, investibleId: pathInvestibleId } = decomposeMarketPath(pathname);
  const values = queryString.parse(querySearch);
  const { groupId, marketId: searchMarketId, investibleId: searchInvestibleId,
    commentId: searchCommentId } = values || {};
  const hashValues = queryString.parse(hash);
  const { marketId: hashMarketId, investibleId: hashInvestibleId, type,
    groupId: hashGroupId, typeObjectId, commentId: hashCommentId } = hashValues || {};
  const [messagesState, messagesDispatch] = useContext(NotificationsContext);
  const syncedMessages = useSyncedMessages();
  const [searchResults] = useContext(SearchResultsContext);
  const [marketPresencesState] = useContext(MarketPresencesContext);
  const [investiblesState] = useContext(InvestiblesContext);
  const [groupsState] = useContext(MarketGroupsContext);
  const [groupPresencesState] = useContext(GroupMembersContext);
  const [marketsState] = useContext(MarketsContext);
  const [commentsState] = useContext(CommentsContext);
  const openChipNotification = useOpenChipNotification();
  const { results, search } = searchResults;
  const {
    hidden = false,
    loading = false,
    title = '',
    titleIcon,
    children,
    tabTitle,
    appEnabled = true,
    banner,
    isInbox,
    isKeptInMemory,
    openMenuItems,
    navigationOptions,
    showBanner,
    disableSearch = false,
    loadingMessageId = 'loadingMessage',
    outBoxMessages,
    leftNavAdjust,
    noPadDesktop,
    isDemoChoice,
    isWizard = false,
    pageBackground
  } = props;

  function navigateFromLeftNav(navigation) {
    const result = navigation();
    clearNavigationOrigins();
    messagesDispatch(clearNavigations());
    return result;
  }
  // B-all-570: no per-tick counting over every message until the sync layer converges
  const initialSyncComplete = useInitialSyncComplete('screen');
  useEffect(() => {
    if (!hidden && !_.isEmpty(tabTitle)) {
      const calcPend = initialSyncComplete ? getInboxCount(syncedMessages) : 0;
      if (calcPend > 0) {
        document.title = `(${calcPend}) ${tabTitle}`;
      } else {
        document.title = `${tabTitle}`;
      }
    }
  }, [hidden, initialSyncComplete, syncedMessages, tabTitle]);
  if (hidden && !isKeptInMemory) {
    return <React.Fragment/>
  }
  const isDemoLoading = _.isEmpty(userState?.user) ||
    OnboardingState.NeedsOnboarding === userState.user.onboarding_state;
  const investibleId = pathInvestibleId || searchInvestibleId || hashInvestibleId;
  const commentId = searchCommentId || hashCommentId;
  let pathMarketId = undefined;
  let pathGroupId = undefined
  if (action === 'inbox') {
    const message = messagesState?.messages?.find((message) => message.type_object_id === pathMarketIdRaw &&
      !message.deleted);
    if (message) {
      pathMarketId = message.market_id;
      pathGroupId = message.group_id;
    } else {
      // Outbox
      const outboxMessage = outBoxMessages?.find((message) => message.id === pathMarketIdRaw);
      pathMarketId = outboxMessage?.marketId;
      pathGroupId = outboxMessage?.group_id;
    }
  } else if (['comment', 'dialog', 'groupManage'].includes(action)) {
    pathMarketId = pathMarketIdRaw;
  } else if (action === 'invite') {
    const decoded = jwt_decode(pathMarketIdRaw);
    pathMarketId = decoded.id;
  }
  let marketId = pathMarketId || searchMarketId || hashMarketId ||
    getPlanningMarketId(investibleId, marketsState, investiblesState);
  const aMarket = getMarket(marketsState, marketId);
  let useLink;
  if (aMarket && aMarket.market_type !== PLANNING_TYPE) {
    marketId = aMarket.parent_comment_market_id;
    const parentComment = getComment(commentsState, marketId, aMarket.parent_comment_id);
    if (parentComment) {
      useLink = formCommentLink(marketId, parentComment.group_id, parentComment.investible_id, parentComment.id);
    }
  }
  const myNotHiddenMarketsState = getNotHiddenMarketDetailsForUser(marketsState, marketPresencesState);
  let markets = [];
  if (myNotHiddenMarketsState.marketDetails) {
    const filtered = myNotHiddenMarketsState.marketDetails.filter((market) =>
      market.market_type === PLANNING_TYPE);
    markets = getSortedMarkets(filtered);
  }
  const isTopLevelInbox = action === 'inbox' && _.isEmpty(pathMarketIdRaw);
  const defaultMarket = getFirstWorkspace(markets, marketId, !isTopLevelInbox, !isTopLevelInbox) || {};
  const reallyAmLoading = !hidden && !isDemoChoice && appEnabled && 
  (loading || (!userIsLoaded(userState, marketsState) && action !== 'wizard'));
  if (marketId && _.isEmpty(defaultMarket)) {
    return <React.Fragment/>
  }

  function setMarketIdFull(newMarketId) {
    setCurrentWorkspace(newMarketId);
    navigate(history, formMarketLink(newMarketId, newMarketId));
  }
  if (marketId && !hidden) {
    if (action === 'dialog' && defaultMarket.id !== marketId) {
      // Handle they are on banned market
      setMarketIdFull(defaultMarket.id);
    } else if (getCurrentWorkspace() !== marketId) {
      setCurrentWorkspace(marketId);
    }
  }

  const useGroupId = groupId ? groupId : (investibleId ?
    getGroupForInvestibleId(investibleId, defaultMarket.id, investiblesState) :
    (pathname === '/' && !isInbox ? defaultMarket.id :
      (commentId ? getGroupForCommentId(commentId, defaultMarket.id, commentsState) : undefined)));
  const navListItemTextArray = [];
  const inactiveGroups = [];
  const isArchivedWorkspace = defaultMarket?.market_stage !== 'Active';
  if (!_.isEmpty(defaultMarket) && !_.isEmpty(groupsState[defaultMarket.id])&&!isArchivedWorkspace) {
    const { useHoverFunctions, resetFunction } = navigationOptions || {};
    getSidebarGroups(isDark, navListItemTextArray, groupsState, marketPresencesState, groupPresencesState,
      history, defaultMarket, useGroupId || pathGroupId || hashGroupId, groupId, classes, useHoverFunctions, search,
      results, openMenuItems, inactiveGroups, pathname, resetFunction, mobileLayout, syncedMessages, commentsState,
      investiblesState, investibleId, initialSyncComplete, navigateFromLeftNav, openChipNotification,
      messagesState.messages);
  }
  const composeChosen = action === 'wizard' && type === COMPOSE_WIZARD_TYPE.toLowerCase();
  const navigationMenu = isDemoLoading ? {} :
    {
      navMenu: <WorkspaceMenu markets={markets} defaultMarket={defaultMarket} setChosenMarketId={setMarketIdFull}
                              inactiveGroups={inactiveGroups} chosenGroup={useGroupId || hashGroupId}
                              navigateFromLeftNav={navigateFromLeftNav} />,
      navLowerMenu: <OtherWorkspaceMenus markets={markets} defaultMarket={defaultMarket} mobileLayout={mobileLayout} 
                      action={action} chosenGroup={useGroupId || hashGroupId} setChosenMarketId={setMarketIdFull}
                      navigateFromLeftNav={navigateFromLeftNav} />,
      navLowerListItemTextArray: !_.isEmpty(defaultMarket) && !isArchivedWorkspace ? [
        {
          icon: EditOutlinedIcon, text: intl.formatMessage({ id: 'compose' }),
          isBold: composeChosen, isBlue: composeChosen, iconColor: isDark ? DARK_ACTION_BUTTON_COLOR : 'black', 
          target: `/wizard#type=${COMPOSE_WIZARD_TYPE.toLowerCase()}&marketId=${defaultMarket.id}`
        }
      ] : null,
      navListItemTextArray
    };
  const myContainerClass = !mobileLayout ? (noPadDesktop ? classes.containerAllNoPad : classes.containerAllLeftPad)
    : classes.containerAll;
  const contentClass = mobileLayout ? classes.contentNoStyle : classes.content;
  const sideNavigationContents = (
    <RenderCensus id="Sidebar">
      <Sidebar navigationOptions={navigationMenu} marketId={defaultMarket?.id}
               navigateFromLeftNav={navigateFromLeftNav} />
    </RenderCensus>
  );
  const renderBanner = showBanner && banner && !hidden;
  return (
    <div className={hidden ? classes.hidden : classes.root} id="root" 
       style={{backgroundColor: isWizard ? theme.palette.background.wizard : undefined}}>
      {!hidden && (
        <Header
          title={title}
          titleIcon={titleIcon}
          hidden={reallyAmLoading}
          appEnabled={appEnabled}
          navMenu={sideNavigationContents}
          disableSearch={disableSearch}
          action={action} pathInvestibleId={pathInvestibleId} defaultMarket={defaultMarket} 
          chosenGroup={useGroupId || hashGroupId}
          pathMarketIdRaw={pathMarketIdRaw} hashInvestibleId={hashInvestibleId} isArchivedWorkspace={isArchivedWorkspace}
          useLink={useLink} typeObjectId={typeObjectId}
        />
      )}
      {!mobileLayout && !hidden && !reallyAmLoading && (
        <div className={classes.paper}>
          {sideNavigationContents}
        </div>
      )}

      <div className={contentClass} data-page-scroll-container={!hidden} style={{
        maxWidth: leftNavAdjust ? `calc(100vw - ${leftNavAdjust}px)` : undefined,
        backgroundColor: pageBackground || undefined
      }}>
        {!reallyAmLoading && (
          <div className={myContainerClass}>
            {renderBanner && (
              <div className={classes.bannerContainer}>
                {banner}
              </div>
            )}
            <div>
              {children}
            </div>
          </div>
        )}
        {reallyAmLoading && (
         <LoadingDisplay showMessage messageId={loadingMessageId} />
        )}
      </div>
    </div>
  );
}

Screen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  breadCrumbs: PropTypes.arrayOf(PropTypes.object),
  hidden: PropTypes.bool,
  loading: PropTypes.bool,
  title: PropTypes.any,
  titleIcon: PropTypes.any,
  children: PropTypes.any,
  tabTitle: PropTypes.string,
  appEnabled: PropTypes.bool,
  banner: PropTypes.node,
  disableSearch: PropTypes.bool,
  loadingMessageId: PropTypes.string,
  pageBackground: PropTypes.string
};

export default Screen;
